import { render, staticRenderFns } from "./ResetPasswordAuthResult.vue?vue&type=template&id=40669368&scoped=true"
import script from "./ResetPasswordAuthResult.vue?vue&type=script&lang=js"
export * from "./ResetPasswordAuthResult.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordAuthResult.vue?vue&type=style&index=0&id=40669368&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40669368",
  null
  
)

export default component.exports